import { DataLoadedStatus, PolicyAppState } from '../../types';
import { ModuleId, SectionId } from '@nirvana/shared/dtos/types/policies/common';
import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { PoliciesReduxActions } from '../../actions';

// SELECTORS
export const getIsLoadingSummaryWindowState = (state: PolicyAppState): boolean =>
  state.modules[ModuleId.PATCH_MANAGEMENT]?.sections[SectionId.NONE].summaryWindow.isLoading ?? false;
export const getSelectedWindowIds = (state: PolicyAppState): Array<string> =>
  state.modules[ModuleId.PATCH_MANAGEMENT]?.sections[SectionId.NONE].summaryWindow.selectedWindowIds ?? [];
export const getIsPatchManagementAdditionalInfoLoaded = (state: PolicyAppState): DataLoadedStatus =>
  state.modules[ModuleId.PATCH_MANAGEMENT]?.sections[SectionId.NONE].additionalInfo.availableMaintenanceWindowsLoaded ??
  DataLoadedStatus.NOT_LOADED;

// ACTIONS
export const setIsLoadingForPatchSummaryWindow = createAction<boolean>(
  PoliciesReduxActions.SET_IS_LOADING_FOR_PATCH_SUMMARY_WINDOW
);
export const setIsLoadingForPatchSummaryWindowActionHandler = (
  state: PolicyAppState,
  action: PayloadAction<boolean>
): void => {
  const module = state.modules[ModuleId.PATCH_MANAGEMENT];

  if (!module) {
    return;
  }

  module.sections[SectionId.NONE].summaryWindow.isLoading = action.payload;
};

export const setSelectedIdsForPatchSummaryWindow = createAction<Array<string>>(
  PoliciesReduxActions.SET_SELECTED_IDS_FOR_PATCH_SUMMARY_WINDOW
);
export const setSelectedIdsForPatchSummaryWindowActionHandler = (
  state: PolicyAppState,
  action: PayloadAction<Array<string>>
): void => {
  const module = state.modules[ModuleId.PATCH_MANAGEMENT];

  if (!module) {
    return;
  }

  module.sections[SectionId.NONE].summaryWindow.selectedWindowIds = action.payload;
};

export const setAvailableMaintenanceWindowsLoadedForPatch = createAction<DataLoadedStatus>(
  PoliciesReduxActions.SET_AVAILABLE_MAINTENANCE_WINDOWS_LOADED_FOR_PATCH
);
export const setAvailableMaintenanceWindowsLoadedForPatchActionHandler = (
  state: PolicyAppState,
  action: PayloadAction<DataLoadedStatus>
): void => {
  const module = state.modules[ModuleId.PATCH_MANAGEMENT];

  if (!module) {
    return;
  }

  module.sections[SectionId.NONE].additionalInfo.availableMaintenanceWindowsLoaded = action.payload;
};
